import { render, staticRenderFns } from "./FieldBoolean.vue?vue&type=template&id=5c8add5c&lang=pug&"
import script from "./FieldBoolean.vue?vue&type=script&lang=ts&"
export * from "./FieldBoolean.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports